module.exports = new __parcel__URL__("LightError.5b516166.png").toString();